module.exports = __webpack_public_path__ + "static/media/U.a65dfa60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/U.jpg
// module id = 89
// module chunks = 0